import { useRef } from "react";
import Modal from "react-bootstrap/Modal";
import { BsUpload, BsX } from "../../../assets/icons/vander";
import { formatEventDate } from "../../../helpers";
import { useScheduleEventStore } from "../../hooks";
import {
  ErrorMessage,
  LoadingData,
  MainButton,
  CancelButtonOutline,
} from "../../ui";

export const ConfirmAssessmentModal = ({
  isOpen,
  setIsOpen,
  onSubmit,
  propsForm,
}) => {
  // Datos del hook ----------------------------------------//
  const {
    // Props
    scheduleEvent,
  } = useScheduleEventStore();

  const {
    uploadFiles,
    formState,
    onFileInputChange,
    onFileRemove,
    fileError,
    isLoading,
  } = propsForm;

  // States ------------------------------------------------//
  const fileInputRef = useRef();
  // Formulario --------------------------------------------//
  // Funciones ---------------------------------------------//
  // Efectos -----------------------------------------------//
  return (
    <Modal
      show={isOpen}
      onHide={() => {
        setIsOpen(false);
      }}
      centered
      size="lg"
    >
      <Modal.Header closeButton>
        <h5 className="modal-title">Confirma tu agendamiento</h5>
      </Modal.Header>
      <Modal.Body>
        {scheduleEvent && (
          <div className="vstack gap-3">
            <p className="mb-0">
              <b>Título: </b>
              {scheduleEvent.title}
            </p>
            <p className="mb-0">
              <b>Fecha y hora de inicio: </b>
              {formatEventDate(scheduleEvent.start)}
            </p>
            <p className="mb-0">
              <b>Fecha y hora de fin: </b>
              {formatEventDate(scheduleEvent.end)}
            </p>
            {uploadFiles && (
              <div>
                <p className="mb-0">
                  Subir exámenes médicos{" "}
                  <span className="text-gray-500">
                    (opcional - Sólo PDF y/o imágenes)
                  </span>
                </p>
                <input
                  type="file"
                  name="files"
                  ref={fileInputRef}
                  style={{ display: "none" }}
                  onChange={onFileInputChange}
                  accept="application/pdf,image/*"
                  multiple
                />
                <button
                  className="btn btn-secondary px-2-5 py-1-5"
                  onClick={() => fileInputRef.current.click()}
                >
                  <BsUpload className="icons me-2" /> Subir
                </button>
                {fileError && <p className="text-danger mb-0">{fileError}</p>}
              </div>
            )}
            {formState.files.length > 0 && (
              <div className="d-flex flex-wrap gap-2">
                {Array.from(formState.files).map((file, index) => (
                  <div
                    className="border border-secondary p-2 rounded-pill"
                    key={index}
                  >
                    {file.name}
                    <BsX
                      onClick={() => onFileRemove("files", index)}
                      style={{
                        cursor: "pointer",
                        width: "20px",
                        height: "20px",
                      }}
                      className="ms-2"
                    />
                  </div>
                ))}
              </div>
            )}
            {/* Mensajes */}
            {isLoading && <LoadingData />}
          </div>
        )}
      </Modal.Body>
      <Modal.Footer>
        <CancelButtonOutline type="button" onClick={() => setIsOpen(false)}>
          Cancelar
        </CancelButtonOutline>
        <MainButton type="button" onClick={onSubmit} disabled={isLoading}>
          Agendar
        </MainButton>
      </Modal.Footer>
    </Modal>
  );
};
